export default __webpack_public_path__ + "static/media/stepsThreeFrame.c6d52986.svg";